const lists = {
    "languages_list":{
        "ro":"Румынский",
        "ru":"Русский",
    },
    "genders_list":{
        null:"Не указано",
        "male":"Мужчина",
        "female":"Женщина",
    }
};
export default lists